(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aos-image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeEquipmentGallery(gallerySection) {
      if (!gallerySection) return;

      if (gallerySection.dataset.galleryInitialized === 'true') {
        return;
      }

      const triggers = Array.from(
        gallerySection.querySelectorAll('[data-gallery-lightbox]')
      );

      const modal = gallerySection.querySelector('[data-gallery-modal]');
      const modalImage = gallerySection.querySelector('[data-gallery-image]');
      const modalTitle = gallerySection.querySelector('[data-gallery-title]');
      const modalDescription = gallerySection.querySelector(
        '[data-gallery-description]'
      );
      const closeButton = gallerySection.querySelector('[data-gallery-close]');
      const previousButton = gallerySection.querySelector(
        '[data-gallery-previous]'
      );
      const nextButton = gallerySection.querySelector('[data-gallery-next]');

      if (
        !modal ||
        !modalImage ||
        !modalTitle ||
        !modalDescription ||
        !closeButton ||
        !previousButton ||
        !nextButton ||
        triggers.length === 0
      ) {
        return;
      }

      gallerySection.dataset.galleryInitialized = 'true';

      let currentIndex = 0;
      let lastFocusedElement = null;

      function renderImage(index) {
        const trigger = triggers[index];

        if (!trigger) return;

        currentIndex = index;

        modalImage.src = trigger.dataset.fullImage || '';
        modalImage.alt =
          trigger.dataset.imageTitle || 'Equipment gallery image';

        modalTitle.textContent = trigger.dataset.imageTitle || '';
        modalDescription.textContent =
          trigger.dataset.imageDescription || '';
      }

      function openModal(index) {
        lastFocusedElement = document.activeElement;

        renderImage(index);

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        window.requestAnimationFrame(function () {
          closeButton.focus();
        });
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      }

      function showPrevious() {
        const previousIndex =
          currentIndex === 0
            ? triggers.length - 1
            : currentIndex - 1;

        renderImage(previousIndex);
      }

      function showNext() {
        const nextIndex =
          currentIndex === triggers.length - 1
            ? 0
            : currentIndex + 1;

        renderImage(nextIndex);
      }

      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () {
          openModal(index);
        });
      });

      closeButton.addEventListener('click', closeModal);
      previousButton.addEventListener('click', showPrevious);
      nextButton.addEventListener('click', showNext);

      modal.addEventListener('click', function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });

      gallerySection.addEventListener('keydown', function (event) {
        if (!modal.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          closeModal();
        }

        if (event.key === 'ArrowLeft') {
          showPrevious();
        }

        if (event.key === 'ArrowRight') {
          showNext();
        }
      });
    }

    function initializeAllEquipmentGalleries(root) {
      const searchRoot = root || document;

      if (
        searchRoot.matches &&
        searchRoot.matches('[id^="EquipmentGallery-"]')
      ) {
        initializeEquipmentGallery(searchRoot);
      }

      searchRoot
        .querySelectorAll('[id^="EquipmentGallery-"]')
        .forEach(function (gallerySection) {
          initializeEquipmentGallery(gallerySection);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAllEquipmentGalleries(document);
      });
    } else {
      initializeAllEquipmentGalleries(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAllEquipmentGalleries(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
